import React, { useEffect } from "react";
import ApiDataService from "../services/ApiDataService";
import { useQuery } from "react-query";
import LangParam from "../types/LangParam";
import { useParams } from "react-router-dom";
import ProductCategory from "../types/ProductCategory";
import MountingTypeField from "../types/MountingTypeField";
import MountingType from "../types/MountingType";
import Color from "../types/Color";
import { useSelectedContextState } from "../context/selectedContext";

type FetchDataProps = {
  selectedColorId?: number;
  selectedMountingTypeId?: number;
  selectedProductId?: number;

  products: (value: ProductCategory[]) => any;
  mountingTypes: (value: MountingType[]) => any;
  colors: (value: Color[]) => any;
  fields: (value: MountingTypeField[]) => any;
};

const FetchData = (props: FetchDataProps) => {
  const {
    selectedColorId,
    selectedMountingTypeId,
    selectedProductId,
    products,
    mountingTypes,
    colors,
    fields,
  } = props;

  let { languageId }: LangParam = useParams();

  const [, dispatch] = useSelectedContextState();

  const getMountingTypes = async (id?: number) => {
    if (id) {
      return await ApiDataService.getMountingTypes(languageId as string, id);
    }
  };

  const getColors = async (id?: number) => {
    if (id) {
      return await ApiDataService.getColors(languageId as string, id);
    }
  };

  const getMountingTypeFields = async (
    mountingTypeId?: number,
    productCategoryId?: number
  ) => {
    if (mountingTypeId !== undefined && productCategoryId !== undefined) {
      return await ApiDataService.getMountingTypeFields(
        languageId as string,
        mountingTypeId,
        productCategoryId
      );
    }
  };

  const { data, isLoading: productIsLoading } = useQuery<any, Error>(
    "productCategories",
    async () => {
      return await ApiDataService.getProductCategories(languageId as string);
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!languageId,
      retry: 2,
      onSuccess: (data) => {
        products(data.productCategories);
      },
      onError: (err: any) => {
        //console.log(err.response?.data || err);
      },
    }
  );

  const { isLoading: mountingTypesLoading } = useQuery<any, Error>(
    ["mountingType", selectedProductId],
    () => getMountingTypes(selectedProductId),
    {
      refetchOnWindowFocus: false,
      enabled: !!selectedProductId,
      retry: 2,
      onSuccess: (data) => {
        mountingTypes(data.mountingTypes);
      },
      onError: (err: any) => {
        //console.log(err.response?.data || err);
      },
    }
  );

  const { isLoading: colorsLoading } = useQuery<any, Error>(
    ["colors", selectedProductId],
    () => getColors(selectedProductId),
    {
      refetchOnWindowFocus: false,
      enabled: !!selectedProductId,
      retry: 2,
      onSuccess: (data) => {
        colors(data.colors);
      },
      onError: (err: any) => {
        //console.log(err.response?.data || err);
      },
    }
  );

  const { isLoading: fieldsLoading } = useQuery<any, Error>(
    ["mountingTypeFields", selectedMountingTypeId],
    () => getMountingTypeFields(selectedMountingTypeId, selectedProductId),
    {
      refetchOnWindowFocus: false,
      enabled: !!selectedMountingTypeId && !!selectedColorId,
      retry: 2,
      onSuccess: (data) => {
        fields(data.fields);
      },
      onError: (err: any) => {
        //console.log(err.response?.data || err);
      },
    }
  );

  useEffect(() => {
    productIsLoading
      ? dispatch({ type: "setProductLoading", payload: true })
      : dispatch({ type: "setProductLoading", payload: false });

    mountingTypesLoading
      ? dispatch({ type: "setMountingLoading", payload: true })
      : dispatch({ type: "setMountingLoading", payload: false });

    colorsLoading
      ? dispatch({ type: "setColorLoading", payload: true })
      : dispatch({ type: "setColorLoading", payload: false });

    fieldsLoading
      ? dispatch({ type: "setMeasurementsLoading", payload: true })
      : dispatch({ type: "setMeasurementsLoading", payload: false });
  }, [
    colorsLoading,
    dispatch,
    fieldsLoading,
    mountingTypesLoading,
    productIsLoading,
  ]);

  return <></>;
};

export default FetchData;
